Uploads a candidate and their profile into SEEK's systems.
